if (!customElements.get("sticky-atc")) {
  customElements.define(
    "sticky-atc",
    class StickyAtc extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          prodTitle: ".m-sticky-addtocart--title",
          mainImage: ".m-sticky-addtocart--image",
          addToCart: ".m-add-to-cart",
          buyNowBtn: ".m-product-dynamic-checkout",
          variantIdSelect: '[name="id"]',
          foxkitBtn: ".foxkit-button",
          select: "select",
        };
        this.hasCustomFields = !!document.querySelector(".m-main-product--info .m-product-custom-field");
      }

      connectedCallback() {
        this.mainProduct = document.querySelector("product-info[id^='MainProduct']");
        this.container = this.closest(".m-sticky-addtocart");
        this.mainProductForm = document.querySelector(".m-product-form--main");
        this.mainProductInfo = document.querySelector(".m-main-product--info");
        this.mainAddToCart = this.mainProductForm.querySelector(".m-add-to-cart");
        this.mainDynamicCheckout = this.mainProductForm.querySelector(this.selectors.buyNowBtn);
        this.disableSelectedVariantDefault = this.mainProduct.dataset.disableSelectedVariantDefault === "true" || false;
        this.domNodes = queryDomNodes(this.selectors, this.container);

        this.init();
      }

      init() {
        if (!this.mainAddToCart) {
          this.container.style.setProperty("--m-translate-y", 0);
          return;
        }

        this.variantData = this.getVariantData();

        const checkVisibility = () => {
          if (!this.mainProductForm && !this.mainAddToCart) return;
          const target = this.mainAddToCart || this.mainProductForm;
          const rect = target.getBoundingClientRect();
          const headerHeight = (window.MinimogSettings && window.MinimogSettings.headerHeight) || 66;

          // Target has scrolled past the header/top of viewport
          const isPast = rect.bottom < headerHeight;

          // Check if footer has started (top of footer has reached or entered viewport)
          const footerSelectors = [
            ".sarthi-footer-wrap",
            "[id*='sarthi_footer']",
            "[id*='sarthi-footer']",
            ".shopify-section-group-footer-group",
            "[id*='footer-group']",
            "m-footer",
            ".m-footer",
            "footer",
            "#shopify-section-footer",
            "[data-section-type='footer']"
          ];
          const footers = document.querySelectorAll(footerSelectors.join(","));
          let isFooterReached = false;
          footers.forEach((el) => {
            const r = el.getBoundingClientRect();
            // As soon as the top of the footer reaches the bottom of the viewport
            if (r.height > 0 && r.top < window.innerHeight) {
              isFooterReached = true;
            }
          });

          // Show sticky cart only when past main buy buttons AND before footer starts
          if (isPast && !isFooterReached) {
            this.container.style.setProperty("--m-translate-y", "0");
            document.documentElement.classList.add("stick-atc-show");
          } else {
            this.container.style.setProperty("--m-translate-y", "100%");
            document.documentElement.classList.remove("stick-atc-show");
          }
        };

        window.addEventListener("scroll", checkVisibility, { passive: true });
        window.addEventListener("resize", checkVisibility, { passive: true });
        checkVisibility();

        if ("IntersectionObserver" in window) {
          this.observer = new IntersectionObserver(
            () => {
              checkVisibility();
            },
            { threshold: [0, 0.05, 0.2, 0.5, 1], rootMargin: "0px 0px 0px 0px" }
          );

          const footerElements = document.querySelectorAll(
            ".sarthi-footer-wrap, [id*='sarthi_footer'], [id*='sarthi-footer'], .shopify-section-group-footer-group, [id*='footer-group'], m-footer, .m-footer, footer, #shopify-section-footer, [data-section-type='footer']"
          );
          footerElements.forEach((footerEl) => {
            this.observer.observe(footerEl);
          });
        }

        if (this.disableSelectedVariantDefault) {
          this.handleDisableSelectedVariantDefault();
        }

        const { prodTitle, mainImage } = this.domNodes;
        if (prodTitle) prodTitle.addEventListener("click", () => __scrollToTop());
        if (mainImage) mainImage.addEventListener("click", () => __scrollToTop());

        this.handleCustomFields();

        this.setObserveTarget();
        this.syncWithMainProductForm();

        const mql = window.matchMedia(MinimogTheme.config.mediaQueryMobile);
        mql.onchange = this.setStickyAddToCartHeight.bind(this);
        this.setStickyAddToCartHeight();

        if (this.domNodes.select) {
          this.domNodes.select.addEventListener("change", (e) => {
            const { target } = e;
            const variantPicker = this.mainProduct.querySelector('variant-picker');
            const selectedVariantId = this.querySelector(this.selectors.variantIdSelect).value;
            this.currentVariant = this.variantData.find((variant) => variant.id === Number(selectedVariantId));
            this.currentVariant ? this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings.soldOut) : this.toggleAddButton(true, window.MinimogStrings.unavailable);

            const selectedOption = target.options[target.selectedIndex];
            const selectedOptionIds = selectedOption && selectedOption.dataset.options ? selectedOption.dataset.options.split(',').filter(id => id) : [];

            if (variantPicker) {
              selectedOptionIds.forEach((optionId) => {
                const input = variantPicker.querySelector(`[data-option-value-id="${optionId}"]`);
                if (input) {
                  const { tagName } = input;
                  switch (tagName) {
                    case "OPTION":
                      const inputParent = input.parentNode; // select tag
                      inputParent.value = input.value;
                      break;
                    case "INPUT":
                      input.checked = true;
                      break;
                  }
                }
              });
              variantPicker.dispatchEvent(new Event("change"));
            }
          });
        }
      }

      getVariantData() {
        const jsonEl = this.container.querySelector('[type="application/json"]');
        if (jsonEl && jsonEl.textContent) {
          this.variantData = this.variantData || JSON.parse(jsonEl.textContent);
        } else {
          this.variantData = [];
        }
        return this.variantData;
      }

      setObserveTarget() {
        if (this.observer && this.mainProductForm) {
          this.observer.observe(this.mainProductForm);
          this.observeTarget = this.mainProductForm;
        }
      }

      setUnavailable() {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');

        if (addButton) {
          this.toggleAddButton(true, window.MinimogStrings.unavailable);
        }
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = this.querySelector('.m-product-form');
        if (!productForm) return;
        const addButton = productForm.querySelector('[name="add"]');
        const addButtonText = productForm.querySelector('[name="add"] > span.m-add-to-cart--text');
        if (!addButton) return;

        if (disable) {
          addButton.setAttribute('disabled', 'disabled');
          if (text && addButtonText) addButtonText.textContent = text;
        } else {
          addButton.removeAttribute('disabled');
          if (addButtonText) addButtonText.innerHTML = window.MinimogStrings.addToCart;
        }

        if (!modifyClass) return;
      }

      handleDisableSelectedVariantDefault() {
        let urlParams = new URLSearchParams(window.location.search);
        if (urlParams.has("variant")) return;

        const pickerFields = this.querySelector('.m-product-option--dropdown-select');
        if (pickerFields) {
          pickerFields.value = '';
          this.setUnavailable();
        }
      }

      setStickyAddToCartHeight() {
        document.documentElement.style.setProperty("--f-sticky-atc-bar-height", this.offsetHeight + "px");
        window.MinimogSettings.stickyAddToCartHeight = this.offsetHeight;
      }

      syncWithMainProductForm() {
        const variantInput = this.querySelector('[name="id"]');
        const priceDisplays = this.container.querySelectorAll('.sarthi-sticky-price-text, .m-sticky-addtocart--title .m-price-item--regular');
        const imgEl = this.container.querySelector('.sarthi-sticky-circle-img, .m-sticky-addtocart--image img');

        if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
          MinimogEvents.subscribe(MinimogTheme.pubSubEvents.variantChange, (e) => {
            const isMainProduct = !e.data.sectionId || (this.mainProduct && e.data.sectionId === this.mainProduct.dataset.sectionId);
            if (!isMainProduct) return;
            this.currentVariant = e.data.variant;
            if (this.currentVariant) {
              if (variantInput) {
                variantInput.value = this.currentVariant.id;
              }
              if (this.domNodes.select) {
                this.domNodes.select.value = this.currentVariant.id;
              }
              // Format and update price
              let priceStr = '';
              if (window.Shopify && Shopify.formatMoney && this.currentVariant.price !== undefined) {
                priceStr = Shopify.formatMoney(this.currentVariant.price);
              } else if (this.currentVariant.price !== undefined) {
                priceStr = '₹ ' + (this.currentVariant.price / 100).toFixed(2);
              }
              if (priceStr) {
                priceDisplays.forEach(el => el.innerHTML = priceStr);
              }
              // Update image if variant has its own image
              if (imgEl && this.currentVariant.featured_image && this.currentVariant.featured_image.src) {
                imgEl.src = this.currentVariant.featured_image.src;
              }
              this.toggleAddButton(!this.currentVariant.available, window.MinimogStrings ? window.MinimogStrings.soldOut : 'Sold Out');
            } else {
              if (variantInput) variantInput.value = '';
              this.toggleAddButton(true, window.MinimogStrings ? window.MinimogStrings.unavailable : 'Unavailable');
            }
          });
        }
      }

      handleCustomFields() {
        if (!this.hasCustomFields) return;

        const { addToCart, buyNowBtn, foxkitBtn } = this.domNodes;

        let hasCustomFieldRequired = false;
        const customFields = document.querySelectorAll(".m-main-product--info .m-product-custom-field");
        let customFieldFirst = customFields[0];
        customFields &&
          customFields.forEach((item) => {
            const field = item.querySelector(".form-field");
            if (field.value == "" && field.hasAttribute("required")) {
              hasCustomFieldRequired = true;
            }
          });

        hasCustomFieldRequired &&
          addToCart.addEventListener("click", (e) => {
            e.preventDefault();
            e.stopPropagation();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        if (buyNowBtn) {
          buyNowBtn.addEventListener(
            "click",
            (e) => {
              const missing = validateForm(this.mainProductInfo);
              if (missing.length > 0) {
                e.preventDefault();
                e.stopPropagation();
                __scrollToTop(this.mainProductInfo, () => this.mainDynamicCheckout.click());
              }
            },
            true
          );
        }
        if (foxkitBtn) {
          foxkitBtn.addEventListener("click", (e) => {
            e.preventDefault();
            __scrollToTop(this.mainProductInfo, () => this.mainAddToCart.click());
          });
        }
      }
    }
  );
}
